import { render } from "./ParameterFilePage.vue?vue&type=template&id=04e80ef4"
import script from "./ParameterFilePage.vue?vue&type=script&lang=js"
export * from "./ParameterFilePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/ParameterFilePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04e80ef4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04e80ef4', __exports__)) {
    api.reload('04e80ef4', __exports__)
  }
  
  module.hot.accept("./ParameterFilePage.vue?vue&type=template&id=04e80ef4", () => {
    api.rerender('04e80ef4', render)
  })

}


export default __exports__